export default {
  title: "",
  subtitle: "Webhook notification",
  path: "webhooks_notifiation",
  paragraphs: [
    "If you want to get a list of all the notifications sent by us, you can use the following endpoint for it. You can also use some filters for it, to search only for the failed ones, or by date.",
    "Example: You can use the endpoint '/notifications?last_id=a5c69e9e-8d84-4b0b-9af8-dcfb5be35093&per_page=1'.",
    "This will return the last notifications after the notifications with ID a5c69e9e-8d84-4b0b-9af8-dcfb5be35093."
  ],
  request: {
    method: "GET",
    endpoint: "/notifications",
    responses: {
      "data": [{
      "url": "https://webhook.site/8efeee1c-8d3d-4d41-95ff-cc2ffb042f4b",
      "sent_at": null,
      "notification": {
        "type": "payment_failed",
        "transaction_id": "173e30f4-9956-4e86-8fc0-d27b125a8678"
      },
      "inserted_at": "2022-09-19T16:21:15.100177",
      "id": "58215ec6-8f2b-40d4-9e50-c790ace92957",
      "failed_at": "2022-09-19T16:21:15.100177"
      }]
    }
  },
  queryPayload: [
    {
      name: "last_id",
      type: "string",
      required: false,
      description: "Id of the last webhook to be excluded from the results"
    },
    {
      name: "per_page",
      type: "string",
      required: false,
      description: "Quantity of results to limit the search"
    },
    {
      name: "order_by",
      type: "string",
      required: false,
      description: "Order by date. Default ordering is ascending (older notifications first). Use 'desc' to order from the newest notifications"
    },
    {
      name: "failed",
      type: "boolean",
      required: false,
      description: "List only failed or successful webhooks. Ignoring this parameter will list both status"
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/NotificationWebhook.js